import { Component, Injectable, OnInit, ViewChild, TemplateRef, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import * as _ from 'lodash';
import { ChatService } from '../../../../common/services/Chat.service';
import { SocketService } from '../../../../common/services/Socket.service';
import { EvsUserService } from '../../../../common/services/EvsUser.service';
import { TicketService } from '../../../../common/services/Ticket.service';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { ContactService } from '../../../../common/services/Contact.service';
import { RoomService } from '../../../../common/services/Room.service';
import { UploadService } from '../../../../common/services/Upload.service';
import { UserService } from '../../../../common/services/User.service';
import { environment } from 'environments/environment';
import { TemplateService } from '../../../../common/services/Template.service';
import { PushNotificationsService } from 'app/common/services/Notifycation.service';
import { DownloadService } from '../../../../common/services/Download.service';
import { CommonService } from 'app/common/services/Common.service';


declare var $: any;

@Component({
    moduleId: module.id,
    selector: "chats",
    templateUrl: './chat.template.html',
    styleUrls: ['../../../../../css/fuck.css', './chat.css'],
    providers: [EvsUserService, TicketService, BsModalService, ContactService, RoomService, UserService, TemplateService, DownloadService, CommonService]
})

@Injectable()
export class ChatComponent implements OnInit, OnDestroy {
    @ViewChild('lgModal') lgModal: ModalDirective;
    modalRef: BsModalRef;

    public list: any = [];
    public list_devide_page: any = [];
    isSorting: any = {};
    user: any = [];
    image_agent = 'assets/images/agent.jpg';
    image_contact = 'assets/images/contact.png';
    no_image = 'assets/images/contact.png';
    public messages: any = [];
    ioConnection: any;
    ioConnection1: any;
    transferConnection: any;
    inviteConnection: any;
    public message: any;
    public ticket_id: any;
    public allAccount: any = [];

    public currentPage: number = 1;
    public page_size: number = 10;
    public history: any = [];
    public alerts: any = {};
    public msg_list: any = {};
    public agent_onlines: any = [];
    public all_agent_onlines: any = [];
    public invite_msg: string = '';
    public msg_obj: any = {};
    public agents_in_ticket: any = [];
    public agents_id_in_ticket: any = [];
    public list_no_received: any = [];
    public can_leave: boolean = false;
    public can_forward: boolean = false;
    public can_receive: boolean = false;
    public onlines: any = {};
    public agents_status: any = {};
    public tab: string = 'online';
    public sender: any = null;

    public inputTicket: any = null;
    public btnHistory: boolean = true;
    public currentTicket: any = null;

    public modelFilter: any = {};
    public listAgent: any = [];
    public allRoom: any = [];
    public totalItem: number = 0;
    public totalPage: number = 0;
    public currentPage_agent: number = 1;
    public room_id: any;
    public friend: any = {};
    public url_server: any = environment.api_evs;
    public templates: any = [];
    public allTemplate: any = [{ id: '', text: '' }];
    public chatTemplate: any;
    public limit: number = 10;
    public totalList: number = 0;
    public isLoad: boolean = false;
    public keyword: string = '';

    @ViewChild('confirm_chat') confirmChat: ElementRef;

    constructor(
        private userService: UserService,
        private contactService: ContactService,
        private chatService: ChatService,
        private ticketService: TicketService,
        private socketService: SocketService,
        private toastr: ToastrService,
        private roomService: RoomService,
        private uploadService: UploadService,
        private modalService: BsModalService,
        private notifycationService: PushNotificationsService,
        private templateService: TemplateService,
        private downloadService: DownloadService,
        private commonService: CommonService
    ) {
        this.user = JSON.parse(localStorage.getItem('User'));
        this.initIoConnection();
        this.socketService.missionAnnounced$.subscribe(
            mission => {
                if (mission.action == 'updateChatData') {
                    this.loadData();
                }
            }
        )
    }


    ngOnInit() {
        this.isSorting['field'] = 'created_at';
        this.isSorting['typeSort'] = 'desc';
        this.loadData();
        this.getTemplate();
        this.tab = 'online'
        if (this.ticket_id && this.inputTicket) this.viewChat(this.ticket_id, true, this.inputTicket);
        // this.getAgentOnline(null);
    }

    ngOnDestroy() {
        if (this.inviteConnection) {
            this.inviteConnection.unsubscribe();
        }

        if (this.transferConnection) {
            this.transferConnection.unsubscribe();
        }
    }

    getAgentOnline(type) {
        
        let payload = {};
        if(this.currentTicket && this.currentTicket.source){
            if(this.currentTicket.source_detail == 'chat'){
                payload['is_chat'] = true;
            } else if(this.currentTicket.source_detail == 'facebook') {
                payload['is_facebook'] = true;
            } else if(this.currentTicket.source_detail == 'zalo'){
                payload['is_zalo'] = true;
            }
        } else {
            payload['is_all'] = true;
        }
        

        this.chatService.agentOnlines(payload).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.agent_onlines = res.data;
                this.all_agent_onlines = this.agent_onlines;
                if (type == 'invite') {
                    this.agent_onlines = _.map(this.agent_onlines, e => {
                        let check = _.find(this.agents_in_ticket, { id: e._id });
                        if (!check) return e;
                        return e;
                    })
                }
            }
        })
    }

    getTemplate(request: any = {}, sort: any = {}) {
        this.templateService.chatTemplate().subscribe(res => {
            this.templates = res.data;
            let templateList = [];
            res.data.forEach((c: any) => {
                templateList.push({
                    id: c.id,
                    text: c.template_name,
                });
            });
            this.allTemplate = templateList;
        });
    }
    useTemplate(id) {
        let template = this.templates.find(x => x.id == id);
        if (template) {
            this.message = template.template_content;
        }
        if (template.attach_file) {
            this.chatTemplate = {
                chatter_id: this.user._id,
                chatter_name: this.user.name,
                chatter_type: 'agent',
                content: template.attach_file,
                type: 'file', //image , file
                avatar: this.user.avatar ? this.user.avatar : '',
                date: Date.now()
            }
        }
    }

    changeTab(type) {
        this.keyword = "";
        this.tab = type;
        this.messages = [];
        this.list = [];
        this.sender = null;
        this.history = [];
        this.ticket_id = null;
        this.currentTicket = null;
        switch (type) {
            case 'online': {
                this.loadData();
                this.getAgentOnline(null);
                break;
            }
            case 'offline': {
                this.loadDataOffline();
                break;
            }
            default: break;
        }
    }

    loadData() {
        this.tab = 'online';
        let request = { filter: 'received' };
        request['limit'] = this.limit;
        request['keyword'] = this.keyword;
        this.chatService.list(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                this.isLoad = false;
                this.list = res.data.chattings;
                this.totalList = res.data.total;
                this.list.forEach(e => {
                    this.alerts[e._id] = e ? e.unread : 0;
                    this.msg_list[e._id] = e ? e.last_msg : '';
                    this.onlines[e._id] = e ? e.is_online : 0;
                });
                // this.list.sort((a,b) => (a.updated_at > b.updated_at) ? 1 : ((b.updated_at > a.updated_at) ? -1 : 0))
                if (this.list.length == 0) this.ticket_id = null;
                else if (!this.ticket_id) this.viewChat(this.list[0]._id, this.list[0].receiver_id, this.list[0]);
                this.list_devide_page = this.list.slice(0, this.limit); // Khi tìm kiếm keyword sẽ gán limit =9999 ở phía server nên this.list cso thể rất lớn
            }
        })
    }

    loadDataOffline() {
        this.tab = 'offline'
        this.ticket_id = null;
        this.history = [];
        this.agents_in_ticket = [];
        let request = { filter: 'no_received' };
        request['limit'] = this.limit;
        request['keyword'] = this.keyword;
        this.chatService.list(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                // this.list = res.data.chattings;
                // if (this.list.length == 0) {
                //     this.ticket_id = null;
                // } 
                // this.list.forEach(e => {
                //     this.alerts[e._id] = e ? e.unread : 0;
                //     this.msg_list[e._id] = e ? e.last_msg : '';
                // });
                // only agent routed or supervisor can view chat list
                this.list = [];
                let temp = res.data.chattings;
                this.isLoad = false;
                this.totalList = res.data.total;
                //console.log("chat list " + JSON.stringify(temp));
                if (temp.length == 0) {
                    this.ticket_id = null;
                }
                let amme = false;
                temp.forEach(e => {
                    amme = false;
                    if ((e.agent_uid && e.agent_uid == this.user._id) || this.user.role == 'administrator' || this.user.role == 'supervisor') {
                        amme = true;
                    } else {
                        if (e.in_room) {
                            e.in_room.forEach(id => {
                                if (id == this.user._id) {
                                    amme = true;
                                }
                            });
                        }
                    }
                    if (amme) {
                        this.list.push(e);
                        this.alerts[e._id] = e ? e.unread : 0;
                        this.msg_list[e._id] = e ? e.last_msg : '';
                    }
                });
                this.list_devide_page = this.list.slice(0, this.limit); // Khi tìm kiếm keyword sẽ gán limit =9999 ở phía server nên this.list cso thể rất lớn
            }
        })
    }

    loadAgentsInTicket(ticket_id) {
        this.agents_in_ticket = [];
        this.agents_id_in_ticket = [];
        this.chatService.agentsInTicket(ticket_id, {}).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.agents_in_ticket = res.data;
                this.agents_in_ticket.forEach(e => {
                    this.agents_status[e.id] = e.is_online;
                    this.agents_id_in_ticket.push(e._id);
                });
            }
        })
    }

    /**
     * kết thúc trao đôi ticket chuyển trang thái close
     * @param ticket
     */
    finish(ticket_id) {
        var y = confirm("Bạn có muốn kết thúc trao đổi tại đây không?");
        if (y) {
            let _msg = {
                chatter_id: this.user._id,
                agent_id: this.user._id,
                device_id: localStorage.getItem('agentId'),
                chatter_name: this.user.name,
                chatter_type: 'agent',
                content: '',
                type: 'action-end', //image , file
                avatar: this.user.avatar ? this.user.avatar : '',
                date: Date.now(),
                source_detail: this.currentTicket.source_detail,
                ticket_id: ticket_id
            };
            this.chatService.send(ticket_id, _msg);
            this.saveToTicket(ticket_id);
            this.ticketService.update(ticket_id, { status: 5 }).subscribe(res => {
                if (res.status == 200 && res.error == false) {
                    this.currentTicket['status'] = 5;
                    // setTimeout(() => {
                    //     this.loadData();
                    // }, 2000);
                    this.loadData();
                }
            })
            // goi api ottgateway de end chat
            this.chatService.closeChat(_msg).subscribe(res => {
                // if (res.status == 200 && res.error == false) {
                //     this.loadData();
                // }
            }, error => {
                console.log("end chat error", ticket_id);
            });
        }


    }
    /**
     * Tiếp nhận cuộc hội thoại chưa ai nhận
     * @param ticket_id
     */
    receiverTicket(ticket_id) {
        if (this.tab == 'offline') {
            this.ticketService.updateMany({ _id: ticket_id, receiver_id: null }, { receiver_id: this.user._id }).subscribe(res => {
                if (res.status == 200 && res.error == false) {
                    this.changeTab('online');
                    this.chatService.send(ticket_id, {
                        chatter_id: this.user._id,
                        chatter_name: this.user.name,
                        chatter_type: 'agent',
                        content: '',
                        type: 'action-join', //image , file
                        avatar: '',
                        date: Date.now()
                    })
                }
            })
        }
    }

    @HostListener('scroll', ['$event'])
    onScroll(event: any) {
        if (event.target.offsetHeight + event.target.scrollTop === event.target.scrollHeight) {
            this.alerts[this.ticket_id] = 0;
        }
    }

    getAccounts() {
        this.userService.list().subscribe(res => {
            this.allAccount = res.data.staffs;
        });
    }

    getRooms() {
        this.roomService.allRoom().subscribe(res => {
            let roomList = [];
            res.data.forEach((c: any) => {
                roomList.push({
                    text: c.name,
                    id: c.id.toString(),
                });
            });
            this.allRoom = roomList;
        });
    }

    getStaffs(request: any = {}, sort: any = {}) {
        this.listAgent = [];
        request.offset = this.page_size * (this.currentPage_agent <= 0 ? 0 : this.currentPage_agent - 1);
        request.limit = this.page_size;
        if (Object.keys(sort).length == 2) {
            request['sort_by'] = sort.field + ':' + sort.typeSort
        }
        this.userService.list(request).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.listAgent = res.data.staffs;
                this.totalItem = res.data.total;
                var pageString = (this.totalItem / this.page_size).toString();
                var pageSplit = pageString.split('.');
                var last: any;
                var totalpage = parseInt(pageSplit[0]);
                if (pageSplit.length > 1) {
                    last = pageSplit[1];
                    if (parseInt(last) > 0) {
                        totalpage++
                    }
                }
                this.totalPage = totalpage;


            } else {
                this.listAgent = [];
            }
        })
    }

    setPage(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage_agent) {
                this.currentPage_agent = page;
                this.getStaffs();
            }
        }
        else {

            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage_agent) {
                    this.currentPage_agent = page;
                    this.getStaffs();
                }
            }
        }
    }

    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }

    _keyPress(event: any) {
        if (event.charCode !== 0) {
            const pattern = /[0-9]/;
            const inputChar = String.fromCharCode(event.charCode);

            if (!pattern.test(inputChar)) {
                // invalid character, prevent input
                event.preventDefault();
            }
        }
    }

    filterAgent(event: any = null) {
        let options = {};
        if (!event) {
            if (this.modelFilter.filter_agent_phone && this.modelFilter.filter_agent_phone.trim() != "") {
                options['phone'] = this.modelFilter.filter_agent_phone;
            }
            if (this.modelFilter.room_id) {
                options['room_id'] = this.modelFilter.room_id;
            }
        } else {
            this.modelFilter = {}
        }

        this.getStaffs(options);
    }

    public changedFilterRoom(e: any): void {
        this.modelFilter.room_id = parseInt(e.value);
    }

    viewChat(ticket_id, received?: any, ticket?: any) {
        this.currentTicket = ticket;
        this.btnHistory = true;
        this.currentPage = 0;
        this.messages = [];
        let request = {
        }

        this.chatService.history(ticket.history[this.currentPage]._id, request).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.history = res.data.history;
                setTimeout(() => {
                    var mailContent = document.getElementById('mailContent');
                    if (mailContent) {
                        mailContent.scrollTop = mailContent.scrollHeight;
                    }

                }, 500);
                if (this.currentPage == ticket.history.length - 1) this.btnHistory = false;
            }
        })

        this.ticket_id = ticket_id;
        this.agents_in_ticket = [];
        this.agents_status = {};
        this.loadAgentsInTicket(ticket_id);
        let data = { $set: { unread: 0 } }
        this.ticketService.updateMany({ _id: ticket_id }, data).subscribe(res => {

        })
        this.chatService.join(ticket_id);
        this.can_receive = false;
        this.can_leave = false;
        this.can_forward = false;
        if (ticket && ticket.receiver_id != this.user._id) this.can_leave = true;
        if (ticket && ticket.receiver_id == this.user._id) this.can_forward = true;
        if (ticket && ticket.assign_agent_id == this.user._id) this.can_receive = true;
        if (ticket && ticket.in_room) {
            ticket.in_room.forEach(e => {
                if (e == this.user._id) {
                    this.can_receive = true;
                }
            });
        }
        this.getSender(ticket.requester_id);
        this.socketService.updateChatNotify(this.alerts[ticket_id]);
        this.alerts[ticket_id] = 0;
    }

    getSender(requester_id) {
        this.userService.find({ _id: requester_id }).subscribe(res => {
            this.sender = res.data;
            this.sender['type'] = this.sender.role == 'end_user' ? 'Khách hàng' : 'Chuyên viên';
        })
    }

    leaveRoom() {
        this.ticketService.updateMany({ _id: this.ticket_id }, { $pull: { in_room: this.user._id } }).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.chatService.leave(this.ticket_id);
                this.loadData();
                this.chatService.send(this.ticket_id, {
                    chatter_id: this.user._id,
                    chatter_name: this.user.name,
                    chatter_type: 'agent',
                    content: '',
                    type: 'action-leave', //image , file
                    avatar: '',
                    date: Date.now()
                })

                this.history = [];
                this.messages = [];
                this.agents_in_ticket = [];
                this.ticket_id = null;
            }
        })
    }

    showHistory(page) {
        this.currentPage = page;
        let request = {
        }
        this.chatService.history(this.currentTicket.history[page]._id, request).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                if (this.currentPage == this.currentTicket.history.length - 1) this.btnHistory = false;
                this.history = _.concat(res.data.history, this.history);
                // this.history = res.data.history;
            }
        })
    }

    saveToTicket(ticket_id) {
        this.chatService.saveToTicket(ticket_id).subscribe(res => {
            if (res.status == 200 && res.error == false) {
                this.toastr.success("Lưu trữ lịch sử chat thành công", '', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            }
        })
    }

    forwardChat(agent_id) {
        let payload = {
            agent_id: agent_id,
            from_user_id: this.user._id,
            from_user: this.user.name,
            tenant_id: this.user.tenant_id,
            ticket_id: this.ticket_id,
            status: 'forward'
        }
        this.chatService.forwardChat(payload);
    }

    openUser(user) {
        this.socketService.opentab(user, 'user', 'edit');
    }

    openTicket(ticket_id: any) {
        this.ticketService.find(ticket_id).subscribe(rs => {
            if (rs.status == 200 && rs.error == false) {
                let _ticket = rs.data;
                _ticket._id = ticket_id;
                this.userService.find({ _id: _ticket.requester_id }).toPromise().then(res => {
                    if (res.status == 200 && res.error == false) {
                        _ticket.request = res.data;
                        this.socketService.opentab(_ticket, 'ticket', 'edit');
                    }
                })
            }
        })
    }

    inviteChat(agent_id) {
        this.chatService.inviteChat(agent_id, this.user._id, this.user.name, this.user.tenant_id, this.ticket_id, 'invite');
    }

    chatting() {
        if (this.message && this.message.trim() != '') {
            let _msg = {
                chatter_id: this.user._id,
                chatter_name: this.user.name,
                chatter_type: 'agent',
                content: this.message,
                type: 'text', //image , file
                avatar: this.user.avatar ? this.user.avatar : '',
                date: Date.now(),
                source: this.currentTicket.source,
                source_detail: this.currentTicket.source_detail
            };
            this.messages.push(_msg);
            this.message = '';
            this.chatService.send(this.ticket_id, _msg);
        }
        if (this.chatTemplate) {
            this.chatService.send(this.ticket_id, this.chatTemplate)
            this.messages.push(this.chatTemplate);
            this.chatTemplate = null;
        }
        setTimeout(() => {
            var mailContent = document.getElementById('mailContent');
            mailContent.scrollTop = mailContent.scrollHeight;
            this.message = '';
        }, 200);
    }

    _keydown(event: any) {
        if (event.keyCode == 13) {
            if (this.message && this.message.trim() != '') {
                let _msg = {
                    chatter_id: this.user._id,
                    chatter_name: this.user.name,
                    chatter_type: 'agent',
                    content: this.message,
                    type: 'text', //image , file
                    avatar: this.user.avatar ? this.user.avatar : '',
                    date: Date.now(),
                    source: this.currentTicket.source,
                    source_detail: this.currentTicket.source_detail
                };
                this.messages.push(_msg);
                this.msg_list[this.ticket_id] = _msg.content;

                this.chatService.send(this.ticket_id, _msg);
                setTimeout(() => {
                    var mailContent = document.getElementById('mailContent');
                    mailContent.scrollTop = mailContent.scrollHeight;
                    this.message = '';
                    if (this.list[0]._id != this.ticket_id) {
                        this.list.unshift(this.list.splice(this.list.findIndex(e => e._id == this.ticket_id))[0]);
                    }
                }, 200);
            }
        }
    }

    openConfirmLeave(template: TemplateRef<any>, ticket_id?: any) {
        this.ticket_id = ticket_id;
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false
        }
        this.modalRef = this.modalService.show(template, config);
    }

    selectFriend(friend) {
        if (friend._id != this.user._id) {
            this.friend = friend;
            let config = {
                backdrop: true,
                ignoreBackdropClick: true,
                keyboard: false
            }
            this.modalRef = this.modalService.show(this.confirmChat, config);
        }
    }

    chatInternal(friend_id) {
        if (friend_id != this.user._id) {
            this.chatService.internalChat(friend_id).subscribe(res => {
                this.tab = 'internal';
                if (res.status == 200 && res.error == false) {
                    this.room_id = res.data._id;
                    this.chatService.joinInternal(res.data._id, this.user._id);
                }
            })
        }
    }

    uploadFile(type) {
        if (type == 'image') {
            $('#messageImage').trigger('click');
        } else if (type == 'file') {
            $('#messageFile').trigger('click');
        }
    }

    sendFile($event, type) {
        var files = $event.srcElement.files;
        let file = files[0];
        if (file.size > 5 * 1024 * 1024) {
            this.toastr.error("Dung lượng file tối đa 5Mb", 'Lỗi', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
            return;
        }
        if (/.*\.(png|jpg|jpeg)$/.test(file.name.toLowerCase()) == false && type == 'image') {
            this.toastr.error("Định dạng file gửi không đúng (png, jpg, jpeg)", 'Lỗi', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
            return;
        }
        if (/.*\.(docx|doc|xlsx|xls|pdf)$/.test(file.name.toLowerCase()) == false && type == 'file') {
            this.toastr.error("Định dạng file gửi không đúng (docx, doc, xlsx, xls, pdf)", 'Lỗi', {
                timeOut: 3000,
                positionClass: 'toast-bottom-right'
            });
            return;
        }
        this.uploadService.upload(file).then((res: any) => {
            if (!res.error) {
                let data = {
                    chatter_id: this.user._id,
                    chatter_name: this.user.name,
                    chatter_type: 'agent',
                    content: this.commonService.file(res.data),
                    type: 'file', //image , file
                    date: Date.now(),
                    avatar: this.user.avatar ? this.user.avatar : '',
                };
                this.chatService.send(this.ticket_id, data)
                this.messages.push(data);
                setTimeout(() => {
                    var mailContent = document.getElementById('mailContent');
                    mailContent.scrollTop = mailContent.scrollHeight;
                }, 200);
                $event.target.value = null;
            } else {
                this.toastr.error(res.data.message, 'Lỗi', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right'
                });
            }
        })
    }

    download_file(fileUrl) {
        var fileName = this.get_name_file(fileUrl);
        this.downloadService.downloadFile(fileUrl, fileName);
    }

    get_name_file(file) {
        var arr = file.split('/');
        var fileName = arr.pop();
        return fileName;
    }

    isImage(file) {
        let check = false;
        var extension = file.substr((file.lastIndexOf('.') + 1));
        switch (extension) {
            case 'jpg':
            case 'png':
            case 'gif':
            case 'jpeg':
                check = true;
                break; // the alert ended with pdf instead of gif.
            default: break;
        }
        return check;
    };

    url_file(file) {
        if (file.indexOf('http') != -1) {
            return file;
        } else {
            return environment.api_evs + '/' + file;
        }
    }
    private initIoConnection(): void {
        // this.chatService.initSocket(this.user.tenant_id, this.user._id);

        this.ioConnection = this.chatService.onMessage()
            .subscribe((message: any) => {
                for (let i = 0; i < this.list.length; i++) {
                    if (this.list[i].requester_id == message.chatter_id) {
                        message.avatar = this.list[i].requester_avatar;
                        break;
                    }
                }
                let room_id = message.room_id;
                if (this.ticket_id != room_id) {
                    this.alerts[room_id] = this.alerts[room_id] + 1;
                }
                this.msg_list[room_id] = message.content;
                this.onlines[room_id] = 1;
                if (this.ticket_id == room_id) {
                    this.messages.push(message);
                }

                setTimeout(() => {
                    var mailContent = document.getElementById('mailContent');
                    if (mailContent) {
                        mailContent.scrollTop = mailContent.scrollHeight;
                    }

                    if (this.list && this.list[0] && this.list[0].requester_id != message.chatter_id) {
                        this.list.unshift(this.list.splice(this.list.findIndex(e => e.requester_id == message.chatter_id))[0]);
                    }
                }, 200);
            });

        this.chatService.onRefreshContact().subscribe((message: any) => {
            console.log("onRefreshContact " + JSON.stringify(message));
            if (message.agent_id == this.user._id) {
                this.alerts[message.ticket_id] = this.alerts[message.ticket_id] ? this.alerts[message.ticket_id] + 1 : 1;
            }
        })

        this.chatService.onUpdateChatting().subscribe((message: any) => {
            console.log("onUpdateChatting " + JSON.stringify(message));
            for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].requester_id == message.chatter_id) {
                    message.avatar = this.list[i].requester_avatar;
                    break;
                }
            }
            if (message.user_id == this.user._id) {
                if (this.currentTicket && this.currentTicket._id != message.ticket_id) {
                    this.alerts[message.ticket_id] = this.alerts[message.ticket_id] ? this.alerts[message.ticket_id] + 1 : 1;
                    this.msg_list[message.ticket_id] = message.content;
                    this.notifycationService.generateNotification([{
                        title: message.chatter_name,
                        content: message.content,
                        avatar: message.avatar,
                        icon: message.avatar
                        // icon: rs.data.avatar ? rs.data.avatar : this.no_image
                    }])
                }
            }


        })

        this.chatService.onRefreshStatus().subscribe((message: any) => {
            console.log("onRefreshStatus " + JSON.stringify(message));
            if (message.type == 'contact') {
                if (message.in_room && message.in_room.indexOf(this.user._id) > -1) {
                    this.onlines[message.ticket_id] = message.status;
                }
            } else if (message.type == 'agent') {
                this.agents_status[message.agent_id] = message.status === 0 ? false : true
            }
        })

        this.chatService.onContactRequestChat().subscribe((message: any) => {
            console.log("onContactRequestChat " + JSON.stringify(message));
            if (message.in_room && message.in_room.indexOf(this.user._id) > -1) {
                this.loadData();
            }
        })

        this.inviteConnection = this.chatService.onInviteChat().subscribe((message: any) => {
            this.msg_obj = message;
            if (message.agent_id == this.user._id) {
                if (message.status == 'invite') {
                    // this.invite_msg = message.from_user + " mời bạn tham gia chat với khách hàng";
                    // let config = {
                    //     backdrop: true,
                    //     ignoreBackdropClick: true,
                    //     keyboard: false
                    // }
                    // this.modalRef = this.modalService.show(this.confirmInvite, config);
                } else if (message.status == 'reject') {
                    this.toastr.info(message.from_user + " từ chối tham gia chat cùng", '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.loadAgentsInTicket(message.ticket_id);
                }

            }
        })

        this.transferConnection = this.chatService.onForwardChat().subscribe((message: any) => {
            this.msg_obj = message;
            if (message.agent_id == this.user._id) {
                if (message.status == 'forward') {
                    // this.invite_msg = message.from_user + " chuyển cuộc hội thoại tới bạn hỗ trợ";
                    // let config = {
                    //     backdrop: true,
                    //     ignoreBackdropClick: true,
                    //     keyboard: false
                    // }
                    // this.modalRef = this.modalService.show(this.confirmForward, config);
                } else if (message.status == 'reject') {
                    this.toastr.info(message.from_user + " từ chối tham gia hỗ trợ ", '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                } else {
                    this.history = [];
                    this.agents_in_ticket = [];
                    this.toastr.info(message.from_user + " đồng ý hỗ trợ ", '', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                    this.chatService.leave(this.msg_obj.ticket_id);
                    this.loadData();
                    this.loadAgentsInTicket(message.ticket_id);
                    this.chatService.send(this.msg_obj.ticket_id, {
                        chatter_id: this.user._id,
                        chatter_name: this.user.name,
                        chatter_type: 'agent',
                        content: '',
                        type: 'action-leave', //image , file
                        avatar: '',
                        date: Date.now()
                    })
                    this.ticket_id = null;
                }

            }
        })

        this.chatService.onEvent("connect")
            .subscribe(() => {
                console.log('connected');
            });

        this.chatService.onEvent("disconnect")
            .subscribe(() => {
                console.log('disconnected');
            });
    }

    @HostListener('scroll', ['$event'])
    onLazyload(event: any) {
        let totalScroll1 = event.target.offsetHeight + Math.round(event.target.scrollTop) - 1;
        let totalScroll2 = event.target.offsetHeight + Math.round(event.target.scrollTop);
        let totalScroll3 = event.target.offsetHeight + Math.round(event.target.scrollTop) + 1;
        let scrollHeight = event.target.scrollHeight;
        if ((totalScroll1 === scrollHeight || totalScroll2 === scrollHeight || totalScroll3 === scrollHeight) && !this.isLoad && this.totalList >= this.limit) {
            setTimeout(() => {
                this.limit += 10;
                this.isLoad = true;
                if (this.tab != "offline") {
                    this.loadData();
                } else {
                    this.loadDataOffline();
                }

            }, 500);
        }
    }

}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/chat/chat.component.ts